import React, { Component } from 'react'
import { Container, Form, FormGroup, Label, Input, Button, Progress } from 'reactstrap';
import Header from '../../components/Headers/Header';
import { getAssetById, updateAsset} from 'services/assetService';
import { getCategoryByCultureId } from 'services/categoryService';
import ReactPlayer from 'react-player';
import axios from 'axios';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { confirmAlert } from 'react-confirm-alert';
import { saveAs } from 'file-saver';
import { downloadFileSolo } from 'services/downloadService'
import 'react-confirm-alert/src/react-confirm-alert.css';
import { withAlert } from 'react-alert'
import { zoomMediaAPI } from '../../services/config';
import uuid from 'uuid-random';
import moment from 'moment';

class Edit extends Component {

    constructor(){
        super();
        this.state = {
            assetData: [],
            video: [],
            keywords: [],
            keywordsLabel: [],
            categories: [],
            categoriesValue: [],
            currentCategories: [],
            assetFound: false,
            assetCultureId: null,
            videoFileName: "",
            downloadStartedImage: false,
            downloadStartedVideo: false,
            active: null,
            uploadImageName: null,
            uploadVideoName: null,
            uploadFileProgress: {},
            showUploadArea: false,
            isImageUploaded: false,
            isVideoUploaded: false,
            uploadingFile: '',
            assetNetworkId: 0,
            isUpdating: false
        }
        this.token = window.zoomCrypt.get("token");
        this.network = window.zoomCrypt.get("networkId");
        this.signal = axios.CancelToken.source();
    }

    getAssetDetail = async () => {
        const assetId = this.props.match.params.id;
        const response = await getAssetById(this.token, assetId, this.network);
        if(response.message === undefined){
            this.setState({
                assetCultureId: response.cultureId,
                assetData: response.data,
                video: response.files.files.length > 0 ? response.files.files[0].RemotePath.replace('http://stream', 'https://ssl-stream') + response.files.files[0].FileName + '.' + response.files.files[0].Extension : [],
                ext : response.files.files[0].Extension,
                videoFileName: response.files.files.length > 0 ? response.files.files[0].FileName + '.' + response.files.files[0].Extension : "",
                assetImage: response.data.ImageFileName !== null ? response.data.ImageRemotePath.replace('http://images.','https://images.') + response.data.ImageFileName : "https://dummyimage.com/600x400/000/fff.png&text=Image+Not+Found",
                assetFound: true,
                active: response.data.IsCommercialAllowed,
                assetNetworkId: response.networkId
            })
        }
        else{
            this.setState({
                assetFound: false
            })
        }

        //console.log(this.network, this.state.assetNetworkId)

    }

    getCategories = async () => {
        const assetId = this.props.match.params.id;
        const responseCategory = await getCategoryByCultureId(this.token, this.state.assetCultureId);
        const responseAsset = await getAssetById(this.token, assetId, this.network);
        let initialCurrentCategories = [];
        let initialCategories = [];
        if(responseAsset.message === undefined){

            responseCategory.category.map((category) => {
                if(category.ShortName.includes('IAB'))
                initialCategories.push({
                    value: category.Id,
                    label: category.IsIab ? `${category.Name} ${category.ShortName}` : category.Name
                })
                    responseAsset.data.Category.map((assetCat) => {
                        if(category.Id === assetCat){
                            initialCurrentCategories.push({
                                value: category.Id,
                                label: category.IsIab ? `${category.Name} ${category.ShortName}` : category.Name
                            })
                        }
                    })
                })
            }

        this.setState({
            categories: initialCategories,
            currentCategories: initialCurrentCategories
        })
    }

    refreshPage() {
        this.props.history.push(this.props.match.params.id);
    }

    setKeywords = () => {
        let initKeywords = [];
            if(this.state?.assetData?.Keyword?.length > 0){
                this.state.assetData.Keyword.map((keyword, index) => {
                    initKeywords.push({
                        value: index,
                        label: keyword
                    })
                })
            }

        if(initKeywords.length > 0){
            this.setState({
                keywords: initKeywords
            })
        }
    }

    onUpdateClick = async e => {
        const assetId = this.props.match.params.id;        
        const { assetData, keywordsLabel, categoriesValue } = this.state;
        this.setState({isUpdating: true})
        const response = await updateAsset(this.token,
                                        this.network,
                                        assetId,    
                                        assetData.Title,
                                        keywordsLabel,
                                        categoriesValue,
                                        assetData.Description,
                                        assetData.ContentPartnerId,
                                        this.state.active,
                                        this.state.isImageUploaded ? this.state.uploadImageName.name : undefined,
                                        this.state.isVideoUploaded ? this.state.uploadVideoName.name : undefined);
        
        this.setState({isUpdating: false})
        if(response.status === 200){
            this.refreshPage();
        }
        else{
            const alert = this.props.alert;
            alert.show('An error occured while updating the asset');
        }
    }

    handleChangeTitle = e => {        
        let assetTitle = e.target.value;
        let _assetData = this.state.assetData;
        _assetData['Title'] = assetTitle;
        this.setState({
            assetData: _assetData
        });        
    }

    handleChangeDescription = e => {        
        let assetDescription = e.target.value;
        let _assetData = this.state.assetData;
        _assetData['Description'] = assetDescription;
        this.setState({
            assetData: _assetData
        });
    }

    initKeywordsAndCategories = () => {
        let initKeywordsLabel = [];
        let initCategoriesValue = [];
        this.state.keywords.map((keyword) => {
            initKeywordsLabel.push(keyword.label)
        })

        this.state.currentCategories.map((category) => {
            initCategoriesValue.push(category.value)
        })

        this.setState({
            categoriesValue: initCategoriesValue,
            keywordsLabel: initKeywordsLabel
        })
    }

    handleChangeKeywords = keywords => {
        let initKeywordsLabel = [];   
        let splitKeywords = [];
        let splitted_labels = [];
        let storedLabels = [];

        if (keywords != null) {
            keywords.map((keyword) => {
                if (keyword.__isNew__){
                    splitted_labels = keyword.label.split(/[,]/gi)
                    splitted_labels.map((label) => {
                        label = label.replace(/[^\w\s]/gi, '');
                        label = label.replace(/[\s*]/, '')
                        initKeywordsLabel.push(label)
                        splitKeywords.push({
                            label:label,
                            value:label,
                            __isNew__: true
                        })
                    })
                }
                else
                {
                    splitKeywords.push(keyword)
                    initKeywordsLabel.push(keyword.label)
                    storedLabels.push(keyword.label)
                }
            })
            let cleaned_splitKeywords = splitKeywords
            splitKeywords.map((keyword) =>{
                if (keyword.__isNew__){
                    if (storedLabels.includes(keyword.label)){                       
                        let index = cleaned_splitKeywords.indexOf(keyword)
                        cleaned_splitKeywords.splice(index, 1);
                        index = initKeywordsLabel.indexOf(keyword.label)
                        initKeywordsLabel.splice(index,1);
                    }
                }
            })
    
            this.setState({
                keywords: cleaned_splitKeywords,
                keywordsLabel: initKeywordsLabel
            })   
        }
               
    }

    handleChangeCategory = currentCategories => {
        let initCategoriesValue = [];
        currentCategories = currentCategories ?? [];

        currentCategories.map((category) => {
            initCategoriesValue.push(category.value)
        })

        this.setState({
            currentCategories: currentCategories,
            categoriesValue: initCategoriesValue
        })
    }

    onDownloadVideo = async () => {
        const alert = this.props.alert;
        const fileName = this.state.videoFileName;
        const file = this.state.assetData.BucketFolderId + "/" + this.state.assetCultureId + "/" + fileName;

        this.setState({
            downloadStartedVideo: true
        })

        if(this.state.assetData.hasOwnProperty('BucketFolderId') ){
            const response = await downloadFileSolo(this.token, this.network, file);
            fetch(response.presignedUrl, { method: 'GET' })
            .then(res => res.blob())
            .then(blob => {
                saveAs(blob, fileName)

                this.setState({
                    downloadStartedVideo: false
                })
            })
            .then(alert.show('Download is started. Please Wait !'))
        }else {
            fetch(this.state.video, { method: 'GET' })
            .then(res => res.blob())
            .then(blob => {
                saveAs(blob, fileName)

                this.setState({
                    downloadStartedVideo: false
                })
            })
            .then(alert.show('Download is started. Please Wait !'))
        }
    }

    onDownloadImage = async () => {
        const alert = this.props.alert;
        const fileName = this.state.assetData.ImageFileName;
        const file = this.state.assetData.BucketFolderId + "/" + this.state.assetCultureId + "/" + fileName;

        this.setState({
            downloadStartedImage: true
        })

        if(this.state.assetData.hasOwnProperty('BucketFolderId') ){
            const response = await downloadFileSolo(this.token, this.network, file);
            fetch(response.presignedUrl, { method: 'GET' })
            .then(res => res.blob())
            .then(blob => {
                saveAs(blob, fileName)

                this.setState({
                    downloadStartedImage: false
                })
            })
            .then(alert.show('Download is started. Please Wait !'))
        }else {
            let imageFile = this.state.assetImage;
            fetch(imageFile, { method: 'GET' })
            .then(res => res.blob())
            .then(blob => {
                saveAs(blob, fileName)

                this.setState({
                    downloadStartedImage: false
                })
            })
            .then(alert.show('Download is started. Please Wait !'))
        }
    }

    async componentDidMount(){
        await this.getAssetDetail();
        await this.getCategories();
        this.setKeywords();
        this.initKeywordsAndCategories();
    }

    confirm = () => {
        if(this.state.currentCategories.length > 0) { 
            confirmAlert({ 
                title: 'Update Asset',
                message: 'Are you sure you want to update ?',
                buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.onUpdateClick()
                },
                {
                    label: 'No',
                }
                ]
            });
        } else {
            this.props.alert.error('Category field should contain at least one item');
        }
    };

    handleChangeActive = e => {
        let active = e.target.checked;
        this.setState({ active });
    }

    getFileName = (file) => {      
        let endIndex= file.lastIndexOf('.');
        let _fileName = file.substr(0, endIndex).replace(/\./g,'');
        let _fileExtension = file.substr(endIndex);
        return _fileName + _fileExtension;
    }

    getNewFile = (blob, fileName, type, size) => {
        fileName = this.getFileName(fileName);
        return new File(blob, fileName, {type: type, size: size})
      }

    handleFileVideo = async (event) => {
        const alert = this.props.alert;
        let file = event.target.files[0]
        if(file !== undefined){
          let blob = file.slice(0, file.size, file.type);
          let ext = file.name.substr(file.name.lastIndexOf('.'));
          let changedFile = this.getNewFile([blob], uuid() + ext, file.type, file.size);
          this.setState({
            uploadVideoName: changedFile
          })
        }else{
            alert.show('Please select a file to upload');
        }
    }

    handleFileImage = async (event) => {
        const alert = this.props.alert;
        let file = event.target.files[0]
        if(file !== undefined){
          let blob = file.slice(0, file.size, file.type);
          let ext = file.name.substr(file.name.lastIndexOf('.'));
          let changedFile = this.getNewFile([blob], uuid() + ext, file.type, file.size);
          this.setState({
            uploadImageName: changedFile
          })
        }else{
            alert.show('Please select a file to upload');
        }
    }

    onImageUploadClick = async e => {
        e && e.preventDefault();
        if(this.state.uploadImageName !== null) {
            this.setState({ showUploadArea: true, uploadingFile: this.state.uploadImageName});
            await this.startUpload(this.state.uploadImageName, true);
        }        
    }

    onVideoUploadClick = async e => {
        e && e.preventDefault(); 
        if(this.state.uploadVideoName !== null) {
            this.setState({ showUploadArea: true, uploadingFile: this.state.uploadVideoName });
            await this.startUpload(this.state.uploadVideoName, false);
        }    
    }

    async startUpload(file, isImage) {
        try {
            
            const params = {
              fileName: this.getFileName(file.name),
              fileType: file.type
            };
  
            const headers = {
              'authorization' : 'Bearer ' + this.token,
              'networkid': this.network,
              'assetId': this.props.match.params.id
            }
  
            let resp = await axios.get(`${zoomMediaAPI}/chunkupload/start`, { params, headers: headers, cancelToken: this.signal.token })
            let uploadId = resp.data.uploadId;
  
            return new Promise(resolve => {
                this.uploadMultipartFile(file, uploadId, isImage).then(() => {
                    resolve()
                })
            })
            
          } catch (err) {
            console.log(err)
          }
      }
  
      /* eslint-disable */
      async uploadMultipartFile(file, uploadId, isImage) {
        try {
            let CHUNK_SIZE;
            const fileSize = file.size
            if(fileSize < 100000000){ // < 100 MB
              CHUNK_SIZE = 20000000 // 20 MB
            }else if(fileSize < 500000000){ // < 500 MB
              CHUNK_SIZE = 50000000 // 50 MB
            }else if(fileSize > 500000000){ // >= 1 GB
              CHUNK_SIZE = 100000000 // 100 MB
            }
            const type = file.type
            const CHUNKS_COUNT = Math.floor(fileSize / CHUNK_SIZE) + 1
            let promisesArray = []
            let start, end, blob
  
            const headers = {
              'mimetype': type,
              'size': fileSize,
              'authorization' : 'Bearer ' + this.token,
              'networkId': this.network,
              'assetId': this.props.match.params.id,
            }
  
            let totalUpload = {};
  
            for (let index = 1; index < CHUNKS_COUNT + 1; index++) {
              start = (index - 1) * CHUNK_SIZE
              end = (index) * CHUNK_SIZE
              blob = (index < CHUNKS_COUNT) ? file.slice(start, end) : file.slice(start)
              let getUploadUrlResp = await axios.get(`${zoomMediaAPI}/chunkupload/geturl`, {
                cancelToken: this.signal.token,
                params: {
                  fileName: this.getFileName(file.name),
                  partNumber: index,
                  uploadId: uploadId
                },
                headers : headers
              })
  
              //let { presignedUrl } = getUploadUrlResp.data

              //console.log(presignedUrl)

              let uploadResp = await axios.put(getUploadUrlResp.data.presignedUrl, blob, {
                cancelToken: this.signal.token,
                headers: { },
                onUploadProgress: async (progressEvent) => {
  
                  let keyname = getUploadUrlResp.data.presignedUrl.substr(getUploadUrlResp.data.presignedUrl.indexOf('Signature=') + 11, 15);
                    
                  totalUpload[`${keyname}`] = progressEvent.loaded;                 
  
                 this.setState({
                    uploadFileProgress: totalUpload                  
                  })
  
                }
              }).then(data => {
                return data.headers.etag
              });
              promisesArray.push(uploadResp)
            }
  
            let resolvedArray = await Promise.all(promisesArray)

            //console.log(resolvedArray);
  
            let uploadPartsArray = []
            resolvedArray.forEach((resolvedPromise, index) => {
              uploadPartsArray.push({
                ETag: resolvedPromise,
                PartNumber: index + 1
              })
            })

            //console.log('0000', uploadPartsArray)
  
            let completeUploadResp = await axios.post(`${zoomMediaAPI}/chunkupload/complete`, {
              cancelToken: this.signal.token,
              params: {
                fileName: this.getFileName(file.name),
                parts: uploadPartsArray,
                uploadId: uploadId
              }
            },
            {
              headers : headers
            }).then(() => {              
                if(isImage) {
                    this.setState({isImageUploaded: true})
                }
                else {
                    this.setState({isVideoUploaded: true})
                }
                this.setState({ showUploadArea: false })
                //this.refreshPage();
            })
  
          } catch (err) {
            console.log(err)
          }
    }

    cancelUpload = () => {
        this.signal.cancel("Upload cancelled");
        this.setState({
          showUploadArea: false,
        })
      }

    progressArea(){
        let file = this.state.uploadingFile;
        let fileName = file.name;
        let fileSize = file.size;
              
        let progressValue = 0;        
        for(let ind = 0; ind < Object.keys(this.state.uploadFileProgress).length; ind++){            
            progressValue = progressValue + this.state.uploadFileProgress[Object.keys(this.state.uploadFileProgress)[ind]]                      
        }
        
        
        if(fileSize !== undefined) {
          progressValue = ((progressValue /  fileSize) * 100).toFixed(3);
        }
        else {
          progressValue = 0;
        }

        return(
            <div className="file-upload-progress-area">
                <img width="100" className="mb-2" src="data:image/png;base64,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" alt="zoomin"></img>
                <h4 style={{color: "#fff"}}>Uploading: { fileName } - {(fileSize / (1024*1024)).toFixed(2) } MB | <strong>%{ progressValue }</strong></h4>
                <Progress animated color="success" value={ progressValue } />                
                <div className="cancel-upload">
                  <Button size="sm" color="danger" className="mt-1" onClick={this.cancelUpload}>Cancel Upload</Button>
                </div>
            </div>
        )
    }

    render() {
        const { assetData, video, ext, keywords, currentCategories, categories } = this.state;
        return (
            <div>
                {this.state.showUploadArea || this.state.isUpdating ? <div className="zoom-blur"></div> : "" }
                {this.state.showUploadArea ? this.progressArea() : "" }
                <Header/>
                {this.state.assetFound ? <Container className="mt-10">
                    <Form>
                        <FormGroup>
                            <Label for="asset">Title</Label>
                            <Input type="text" name="assetTitle" id="asset_title" onChange={this.handleChangeTitle} value={assetData.Title || ""}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="asset">Description</Label><br></br>
                            <Input type="textarea" name="assetDesc" id="asset_desc" onChange={this.handleChangeDescription} value={assetData.Description}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="asset">Keywords</Label><br></br>
                            <CreatableSelect
                            value={ keywords }
                            isMulti
                            name="keywords"
                            options={ keywords }
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.handleChangeKeywords}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="asset">Category</Label><br></br>
                            <Select
                            value={ currentCategories }
                            isMulti
                            name="keywords"
                            options={ categories }
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.handleChangeCategory}
                            />
                        </FormGroup>
                        <FormGroup check className="mb-3">
                            <Label check>
                            <Input type="checkbox" checked={this.state.active || false} onChange={this.handleChangeActive}/>{' '}
                                <strong>Is Commercial Allowed</strong>
                            </Label>
                        </FormGroup>
                        <Label><strong>Guid :</strong> {this.state.assetData.Guid}</Label>
                        { assetData.TaskId !== undefined ? 
                            <FormGroup>
                                <Label><strong>Task Id: <a href="#" onClick={(e) => { e.preventDefault(); this.props.history.push(`/admin/process-task/${assetData.TaskId}`)}}>{assetData.TaskId}</a></strong></Label>
                            </FormGroup> : ''
                        }
                        <hr></hr>
                        <FormGroup>
                            <Label for="asset">Current Video</Label> 
                            { (this.network === this.state.assetNetworkId || this.network === 1) ? <Button onClick={this.onDownloadVideo} color="primary" className="asset-download" data-clipboard-text="cloud-download-95" type="button" size="sm"><div className="download-button"><i className="ni ni-cloud-download-95"></i><span>Download Video</span> { this.state.downloadStartedVideo ? <img src="https://samherbert.net/svg-loaders/svg-loaders/oval.svg" className="ml-2" width="14" alt="zoomin"></img> : "" } </div></Button> : ''}
                            { ext === "mp4" && video !== null ? <ReactPlayer width="100%" height="100%" url={ video } controls /> : <h3>Video not found</h3> }
                            {(this.network === this.state.assetNetworkId || this.network === 1) && this.state.assetData.Status === 'C' ?                            
                                <div className="row">
                                    <div className="col">
                                    <Input type="file" accept=".mp4" name="videoFile" onChange={this.handleFileVideo} id="videoUpload"/>
                                    </div>
                                    <div className="col-md-auto">
                                    <Button onClick={this.onVideoUploadClick} color="primary" className="asset-upload" data-clipboard-text="cloud-upload-96" size="sm"><div className="upload-button"><i className="ni ni-cloud-upload-96"></i><span>Upload selected video file</span></div></Button>
                                    </div>
                                </div> : '' }
                                { this.state.isVideoUploaded ? <div><br></br><Label for="asset">Uploaded Video</Label> <ReactPlayer width="100%" height="100%" url={ this.state.assetData.ImageRemotePath + this.state.uploadVideoName.name } controls /> </div> : '' }
                        </FormGroup>
                        <FormGroup>
                            <Label for="asset">Current Image</Label>
                    { (this.network === this.state.assetNetworkId || this.network === 1) ? <Button onClick={this.onDownloadImage} color="primary" className="asset-download" data-clipboard-text="cloud-download-95" type="button" size="sm"><div className="download-button"><i className="ni ni-cloud-download-95"></i><span>Download Image</span> { this.state.downloadStartedImage ? <img src="https://samherbert.net/svg-loaders/svg-loaders/oval.svg" className="ml-2" width="14" alt="zoomin"></img> : "" } </div></Button> : '' } <br></br>
                            <img src={this.state.assetImage} alt="" width="100%" height="620" />                           
                            {(this.network === this.state.assetNetworkId || this.network === 1)  && this.state.assetData.Status === 'C' ?                            
                                <div className="row" style={{marginTop: 8}}>                                    
                                    <div className="col">
                                    <Input type="file" accept=".jpg, *.jpeg" name="imageFile" onChange={this.handleFileImage} id="imageUpload"/>
                                    </div>
                                    <div className="col-md-auto">
                                    <Button onClick={this.onImageUploadClick} color="primary" className="asset-upload" data-clipboard-text="cloud-upload-96" size="sm"><div className="upload-button"><i className="ni ni-cloud-upload-96"></i><span>Upload selected image file</span></div></Button>
                                    </div>
                                </div> : '' }
                            { this.state.isImageUploaded ? <div><br></br><Label for="asset">Uploaded Image</Label><img src={this.state.assetData.ImageRemotePath + this.state.uploadImageName.name} alt="" width="100%" height="620" /></div> : ''}
                        </FormGroup>
                        <FormGroup>
                            <Label>Created By</Label>
                            <Input readOnly type="text" name="createdBy" id="createdBy" value={`${this.state.assetData.CreatedUserName} - ${moment(this.state.assetData.CreatedDate).format("LLLL")}`}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Modified By</Label>
                            <Input readOnly type="text" name="modifiedBy" id="modifiedBy" value={`${this.state.assetData.ModifiedUserName} - ${this.state.assetData.ModifiedDate !== null ? moment(this.state.assetData.ModifiedDate).format("LLLL") : ' - '}`}/>                            
                        </FormGroup>
                    </Form>
                    {(this.network === this.state.assetNetworkId || this.network === 1) ? <Button onClick={this.confirm}>Update Asset</Button> : '' }
                </Container> : <div className="not-found-area"><img src="https://samherbert.net/svg-loaders/svg-loaders/puff.svg" alt="zoomin"></img></div> }
            </div>
        )
    }
}

export default withAlert()(Edit)